import * as React from 'react';

import { NewbuildingCarousel, TDirection, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import classNames from 'clsx';
import { Arrow } from './parts/Arrow';
import { firstPaintOptions, mediaSettings } from './utils/carouselSettings';
import * as style from './VideoCarousel.css';

export interface ICarouselProps {
  slides: React.ReactNode[];
  onSlideChange?(index: number): void;
}

export const VideoCarousel = ({ slides, onSlideChange: onSlideChangeCallback }: ICarouselProps) => {
  const [currentSlide, setCurrentSlide] = React.useState(1);

  const onSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    setCurrentSlide(currentSlide);

    if (onSlideChangeCallback) {
      onSlideChangeCallback(currentSlide);
    }
  };

  const changeSlide = (direction: TDirection) => {
    setCurrentSlide(currentSlide + direction * 1);
  };

  return (
    <div data-testid="VideoCarousel" className={style['carousel']}>
      <div className={style['content']}>
        <div className={classNames(style['arrow'], style['arrow-left'])}>
          <Arrow direction={-1} clickHandler={changeSlide} show={currentSlide > 1} />
        </div>
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={slides}
          defaultCurrentSlide={currentSlide}
          onSlideChange={onSlideChange}
        />
        <div className={classNames(style['arrow'], style['arrow-right'])}>
          <Arrow direction={1} clickHandler={changeSlide} show={currentSlide < slides.length} />
        </div>
      </div>
    </div>
  );
};
